module.exports = __webpack_public_path__ + "home-block-6-image-1p58WeQ.jpg";